import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export const isIterableArray = (array: any): array is string[] => {
  return (
    Array.isArray(array) &&
    !!array.length &&
    array.every((item) => typeof item === 'string')
  )
}
export const getColor = (
  name: string,
  dom: HTMLElement = document.documentElement
) => {
  return getComputedStyle(dom).getPropertyValue(`--falcon-${name}`).trim()
}

export const formatDate = (
  date: string | Date,
  duration: boolean = true,
  format: string = 'YYYY-MM-DD HH:mm:ss.SSS'
): string => {
  const dateFormatted = dayjs(date)
  if (!dateFormatted.isValid()) {
    return 'Date Invalide'
  }
  if (!duration) {
    return dateFormatted.format(format)
  }
  if (dateFormatted.unix() === 0) {
    return 'Jamais'
  }
  return dateFormatted.fromNow()
}
